/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../context';

const useConfigData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const getConfig = async () => {
        const response = await axios.get('/api/kinto/config');
        const changingDataDisplay = response?.data?.map(e =>{
            var obj = {}
            obj[e.name] = e.value
            return obj
        })
        var resultObject = changingDataDisplay.reduce(function(acc, x) {
            for (var key in x) acc[key] = x[key];
            return acc;
        }, {});
        setState((prevState) => ({
            ...prevState,
            config: resultObject,
        }));
    }
   

    const getConfigItem = item => {
        if (state.config[item]) {
            return state?.config[item];
        }
        return null
    }

    return {
        config: state.config,
        getConfigItem,
        getConfig
    };
}

export default useConfigData;